import { useDisclosure, useOutsideClick } from "@chakra-ui/react";
import { useRef } from "react";

export const usePopoverOpenState = (outsideClick = true) => {
  const { isOpen, onToggle, onOpen, onClose } = useDisclosure();
  const ref = useRef(null);
  if (outsideClick) useOutsideClick({ ref, handler: onClose });
  return { isOpen, onToggle, ref, onOpen, onClose };
};
